// Tiny loading spinner component.

import React from 'react';
import FontAwesome from 'react-fontawesome';

interface Props {
  color?: string;
  children?: React.ReactNode;
}

const LoadingSpinner = ({
  color = '#000',
  children = 'Loading...',
  ...props
}: Props): JSX.Element => (
  <div {...props}>
    <div className="loading-spinner-decorate">
      <FontAwesome name="circle-o-notch" spin style={{ color }} />
    </div>
    <span className="loading-spinner-text" style={{ color }}>
      {children}
    </span>
  </div>
);

export default LoadingSpinner;
